import React from 'react'
import PropTypes from 'prop-types'

class Currency extends React.Component {
   render() {
     const full = this.props.children
     const int = Math.trunc(full)
     const cents = Math.trunc(Math.round((full - int) * 100))
     return (
      <span>R$ {int},{cents}{cents === 0 ? '0' : null}</span>
     )
   }
 }
 Currency.propTypes = {
   children: PropTypes.number.isRequired
 }
 
 export default Currency
 


// WEBPACK FOOTER //
// ./src/components/Currency/index.js